import { create } from 'zustand'
import { Language } from '../hooks/useLanguage'

interface LanguageStore {
  language: Language
  setLanguage: (lang: Language) => void
  initializeFromUser: (userConfig: any) => void
}

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: 'es',
  
  setLanguage: (lang: Language) => {
    set({ language: lang })
  },
  
  initializeFromUser: (userConfig: any) => {
    if (!userConfig) {
      set({ language: 'es' })
      return
    }
    
    try {
      const config = typeof userConfig === 'string' 
        ? JSON.parse(userConfig) 
        : userConfig
      
      const lang = (config.language === 'en' ? 'en' : config.language === 'ca' ? 'ca' : 'es') || 'es'
      set({ language: lang })
    } catch {
      set({ language: 'es' })
    }
  },
}))

